"use client";

import React from "react";

//Styles
import { BoxAlignOccupancyRateProps } from "@/types";

//Styles
import * as S from "./styles";

const BoxAlignOccupancyRate: React.FC<BoxAlignOccupancyRateProps> = ({
  className,
  children,
}) => {
  return <S.Box className={className}>{children}</S.Box>;
};

export default BoxAlignOccupancyRate;
